import Footer from "./Footer";
import Header from "./Header";
import MainSoriee from "./Main/MainSoriee";

function Soriee(params) {
  return (
    <div>
      
      <Header />
      <MainSoriee />
      <Footer />
    </div>
  );
}

export default Soriee;